module.exports = __webpack_public_path__ + "public/img/policyCover.88ac1b5c.png";